import type { ExecutionStatus } from '@mct/shared';

import { statusPillClass, statusPillStyle } from '../lib/statusColors';
import { cn } from '../lib/utils';

/**
 * Read-only status badge: the status word itself rendered as a tinted
 * pill (no leading dot). Editable surfaces (e.g. the detail panel's
 * `StatusPill` dropdown) reuse the same {@link statusPillClass} colors
 * but add their own affordances.
 */
export function StatusBadge({
  status,
  className,
}: {
  status: ExecutionStatus;
  className?: string;
}) {
  const { label } = statusPillStyle(status);
  return (
    <span
      data-status={status}
      aria-label={label}
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        statusPillClass(status),
        className,
      )}
    >
      {label}
    </span>
  );
}
